<button class="{{ btnClass }}" (click)="onClick()">
    <ng-content></ng-content>
</button>
